import { render, staticRenderFns } from "./FooterComponent.vue?vue&type=template&id=c11953e6&scoped=true&"
var script = {}
import style0 from "./FooterComponent.vue?vue&type=style&index=0&id=c11953e6&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c11953e6",
  null
  
)

export default component.exports